import * as React from 'react';
import { isEmpty, isNull } from 'lodash';
import { SpaceBetween } from '@amzn/awsui-components-react';
import CreateSurveysComponent from '../CreateRiseSurveyComponent';
import { SURVEY_TYPE } from '../../../../../common/components/pdf_generator/templates/SurveyPDFTemplate/utils/DataUtils';

/*
Survey rendering configuration based on different attributes.
This eliminates different type of conditional rendering on
different combination of attributes and keeps component clean,
configurable and extensible when we will have new types of jurisdiction
and survey type etc
This single config object can be used by different components
which are not directly used as dependency in below config pages
to avoid import/no-cycle
*/
const surveyRenderingConfig = {
  Default: {
    CreateSurveyPage: {
      isConfirmButtonDisabled: state => {
        return (
          isEmpty(state.LaborBCSubstantiation.releaseDate) ||
          isEmpty(state.LaborBCSubstantiation.dueDate) ||
          isNull(state.LaborBCSubstantiation.template)
        );
      },
      renderCreateSurveyComponents: ({ state, setState }) => (
        <SpaceBetween size="xl" className="create-survey-container">
          <CreateSurveysComponent
            surveyType={SURVEY_TYPE.LABOR_BC_SUBSTANTIATION}
            state={state}
            setState={setState}
            populationType={SURVEY_TYPE.LABOR_BC_SUBSTANTIATION}
          />
        </SpaceBetween>
      ),
      surveyTypesToConfirm: [SURVEY_TYPE.LABOR_BC_SUBSTANTIATION],
    },
  },
};

// Traverse through the config using optional chaining, with fallback to defaults
const getSurveyPageRenderingConfig = (clientId, surveyType, page) => {
  const config =
    surveyRenderingConfig?.[clientId]?.[surveyType]?.[page] ||
    surveyRenderingConfig?.Default?.[page]; // Global default config
  return config || {};
};

export default getSurveyPageRenderingConfig;
